import { render, staticRenderFns } from "./EmailVacation.vue?vue&type=template&id=b68dbeb6&scoped=true&"
import script from "./EmailVacation.vue?vue&type=script&lang=js&"
export * from "./EmailVacation.vue?vue&type=script&lang=js&"
import style0 from "./EmailVacation.vue?vue&type=style&index=0&id=b68dbeb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68dbeb6",
  null
  
)

export default component.exports